import { rgba, ThemedFunctor } from '@doveit/bricks';
import { css, keyframes } from 'styled-components';

const flip = keyframes`
  0% {
    transform: rotateY(0deg);
  }
  25% {
    transform: rotateY(-180deg);
  }
  50% {
    transform: rotateY(0deg);
  }
  75% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(0deg);
  }
`;

const color = (color1: string, color2: string) => keyframes`
  0% {
    color: ${color1};
  }
  25% {
    color: ${color2};
  }
  50% {
    color: ${color1};
  }
  75% {
    color: ${color2};
  }
  100% {
    color: ${color1}; /* Torna al colore iniziale */
  }
`;

export const wrapper: ThemedFunctor = () => css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const loading: ThemedFunctor = ({ theme }) => css`
  animation: ${flip} 3s infinite ease-in-out;
  width: 4rem;

  svg {
    animation: ${color(theme.color.foreground.primary.default.low, rgba(theme.color.foreground.primary.default.low, 0.5))} 3s infinite ease-in-out;
  }
`;
